
import React, {createRef} from 'react'
import {connect} from "react-redux";
import {servidor, servicioRestfulCompleto} from "../Configuracion";
import PropTypes from "prop-types";
import Titulo from "../../framework2/ej2/UI/Titulo";
import SignaturePad from 'signature_pad';
import {getValorCampo, onKeyDown, showCampo, showComponente} from "../utils/FormularioUtils";
import {getFormattedDateFromDate} from "../../framework2/ej2/utils/DateUtils";

class ConsentimientoDatos extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            cargandoDatos: false,
            //fecha: (new Date()).toLocaleString(),
            fecha: getFormattedDateFromDate(new Date()),
            esMenorDeEdad: false,
            tutorNombre: "",
            tutorDni: "",
        }
    }

    componentDidMount() {

    }



    //------------------------------------------------------------------------------------------------------------------
    // ACCIONES
    //------------------------------------------------------------------------------------------------------------------

    onCancelar= () => {
        const {onCancelar} = this.props;
        onCancelar && onCancelar();
    }

    onAceptar= () => {
        const{fecha, esMenorDeEdad, tutorNombre, tutorDni} = this.state;
        const {onAceptar} = this.props;

        let datos= {
            fecha: fecha,
            esMenorDeEdad: esMenorDeEdad,
            tutorNombre: tutorNombre,
            tutorDni: tutorDni,
            }

        onAceptar && onAceptar(datos);
    }


    //------------------------------------------------------------------------------------------------------------------
    // RENDER
    //------------------------------------------------------------------------------------------------------------------


    render() {
        const {fecha, esMenorDeEdad, tutorNombre, tutorDni} = this.state;
        const {paciente} = this.props;

        return (
            <div style={{margin: 8, padding: 4}}>
                <div className="fr_seccion">
                    <div className="fr_seccion_contenedor">
                        <div className="fr_campo_contenedor fr_4_col">
                            <label className="fr_campo_label">Fecha</label>
                            <input name="fecha" className="fr_componente" type="text"
                                   value={fecha}
                                   readOnly={true}
                            />
                        </div>
                        <div className="fr_campo_contenedor fr_3_col">
                            <label className="fr_campo_label">Nombre y apellidos</label>
                            <input name="pacienteNombre" className="fr_componente" type="text"
                                   value={paciente.nombre}
                                   readOnly={true}
                            />
                        </div>

                        <div className="fr_campo_contenedor fr_1_col">
                            <label className="fr_campo_label">DNI / CIF</label>
                            <input name="pacienteIdFiscal" className="fr_componente" type="text"
                                   value={paciente.dni}
                                   readOnly={true}
                            />
                        </div>

                        <div className="fr_campo_contenedor fr_4_col">
                            <label className="fr_campo_label">Es menor de edad</label>
                            <input className="fr_checkbox" type="checkbox" id="esMenorDeEdad" name="esMenorDeEdad"
                                   checked={esMenorDeEdad}
                                   onChange={ (event) => {
                                       this.setState({esMenorDeEdad: event.target.checked})
                                   }}
                            />
                        </div>

                        {Boolean(esMenorDeEdad) &&
                        <div className="fr_campo_contenedor fr_3_col">
                            <label className="fr_campo_label">Nombre del tutor</label>
                            <input name="tutorNombre" className="fr_componente" type="text"
                                   value={tutorNombre}
                                   onChange={ (event) => {
                                       this.setState({tutorNombre: event.target.value.toUpperCase()})
                                   }}
                            />
                        </div>
                        }

                        {Boolean(esMenorDeEdad) &&
                            <div className="fr_campo_contenedor fr_1_col">
                                <label className="fr_campo_label">DNI del tutor</label>
                                <input name="tutorDni" className="fr_componente" type="text"
                                       value={tutorDni}
                                       onChange={ (event) => {
                                           this.setState({tutorDni: event.target.value.toUpperCase()})
                                       }}
                                />
                            </div>
                        }

                    </div>
                </div>
                <div style={{ marginTop: 10 }}>
                    <button onClick={this.onCancelar}>Cancelar</button>
                    <button onClick={this.onAceptar} style={{ marginLeft: 10 }}>Aceptar</button>
                </div>

            </div>
        )
    }

}

ConsentimientoDatos.propTypes = {
    paciente: PropTypes.object,
    onAceptar: PropTypes.func,
    onCancelar: PropTypes.func,
}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
    }
}
export default connect(mapStateToProps)(ConsentimientoDatos);



